import { Component, Input, OnInit } from '@angular/core';

const heroImage =  '../../../../../assets/images/hero-bg-gradient-tan-01.png'

@Component({
  selector: 'app-masthead',
  templateUrl: './masthead.component.html',
  styleUrls: ['./masthead.component.scss']
})
export class MastheadComponent implements OnInit {
  @Input() title = '';
  @Input() subtitle = '';
  @Input() image = '';

	// Lifecycle Hooks

	ngOnInit(): void {
		this.image = heroImage;
	}
}
